module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "modify-email"
  }, [_c('steps', {
    attrs: {
      "title": _vm.stepTitle,
      "step": _vm.currentStep
    }
  }), _vm._v(" "), _c(_vm.modify_view, {
    tag: "div",
    attrs: {
      "v_type": _vm.vType,
      "switch_enabled": true,
      "btn_text": _vm.btnText,
      "request": _vm.request,
      "finish_title": _vm.finish_title,
      "modify_type": _vm.stepTitle
    },
    on: {
      "switchValidate": _vm.switchValidate,
      "bind_email_success": _vm.bind_email_success,
      "next": _vm.next,
      "finish": _vm.finish,
      "errorResult": _vm.errorResult
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-15456374!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/validation/email/modify_email.vue
// module id = uMTV
// module chunks = 15